import React from 'react';
import { GetServerSideProps } from 'next';
import { useSelector } from 'react-redux';
import { createGlobalStyle } from 'styled-components';

import { getThemeSelector, getDomain } from '@src/store/selectors';
import reduxWrapper from '@src/store';
import { sendBugMsgCall } from '@src/store/actions/session';
import { setSSRPage } from '@src/store/actions/ssr';
import { defaultActionCalls } from '@src/router/ssr';
import { SSR_PAGE_LEARNING_PATH } from '@src/router/hydrate';
import { getPageTimeoutData } from '@src/utils/deprecatedCommon';

import BusinessLoginPage from '@src/components/business/login';
import BusinessSSoLoginPage from '@src/components/business/sso';
import { isHardcodeSanwaLogin, isHardcodeNamchowLogin } from '@src/utils/hardcode';

const GlobalStyle = createGlobalStyle`
	html {
		display: block !important;
	}
`;
interface ITheme {
	themes: { name: string; closed_sso_enabled: string; closed_sso_type: string }
}

const BusinessLogin = (): JSX.Element => {
	const { themes: { name, closed_sso_enabled, closed_sso_type } } = useSelector(getThemeSelector) as ITheme;
	const domain = useSelector(getDomain) as string;

	let sso_type = closed_sso_type;
	if (isHardcodeSanwaLogin(name)) {
		sso_type = 'sanwa';
	} else if (isHardcodeNamchowLogin(domain)) {
		sso_type = 'namchow';
	}
	return (
		<>
			<GlobalStyle />
			{
				closed_sso_enabled ? <BusinessSSoLoginPage type={sso_type} /> : <BusinessLoginPage />
			}
		</>
	);
};

export const getServerSideProps: GetServerSideProps = reduxWrapper.getServerSideProps(
	async ctx => {
		const { req, store } = ctx;
		const time = 3000;
		const pageTimeout = setTimeout(() => {
			const pageTimeoutData = getPageTimeoutData({ req, time });

			if (pageTimeoutData) {
				store.dispatch(sendBugMsgCall({ msg: JSON.stringify(pageTimeoutData) }));
			}
		}, time);

		store.dispatch(setSSRPage(SSR_PAGE_LEARNING_PATH));

		const success = await new Promise<() => void>(resolve => {
			const unsubscribe = store.subscribe(() => {
				const defaultActionDone = defaultActionCalls.actionDone(ctx);
				if (defaultActionDone) {
					clearTimeout(pageTimeout);
					resolve(unsubscribe);
				}
			});

			defaultActionCalls.actionCall(ctx);
		});
		success();
	},
);

export default BusinessLogin;
